import { render, staticRenderFns } from "./prescriptionDetails.vue?vue&type=template&id=554d4833&"
import script from "./prescriptionDetails.vue?vue&type=script&lang=js&"
export * from "./prescriptionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports